/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ProgressBar from 'Components/header/components/ProgressBar';
import cn from 'classnames';
import RightArrowImg, {
  ReactComponent as RightArrow,
} from 'Assets/category-right-arrow.svg';
import LeftArrowImg, {
  ReactComponent as LeftArrow,
} from 'Assets/category-left-arrow.svg';
import AlterImage from 'Assets/no-image-available.png';
import { dataFetcher, endpoints, axios, baseUrl } from 'Api';
import { ProfilePage, Button } from 'Components';
import { AuthContext, AppContext } from 'Context';
// eslint-disable-next-line
import { Swiper, SwiperSlide } from "swiper/react";
// eslint-disable-next-line
import "swiper/swiper-bundle.min.css"; // ✅ Import full Swiper styles
// eslint-disable-next-line
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import { Pathname } from 'Routes';
import { Image } from 'semantic-ui-react';
import { Box } from '@material-ui/core';
import { CONTENT_TYPES } from 'Pages/private/profile';
import VideoAutoPlayer from './video-autoplayer';
import styles from './index.module.css';
import { TitleLabel } from './video-autoplayer/TitleLabel';

SwiperCore.use([Navigation, Pagination]);
const isTrueValue = true;
const isFalseValue = false;
const ImageGroupTitle = ({
  resumeMe,
  title,
  setResumeMe,
  marginTitle,
  resumeWatching,
  setLoading,
  clearResumeWatching,
}) => (
  <>
    {title && (
      <div className={styles.headingWrapper}>
        <h3
          className={cn({
            [styles.imageGroupTitle]: true,
            [styles.marginTitle]: !marginTitle,
          })}
        >
          {title}
        </h3>
        {resumeMe?.content?.length > 0 ? (
          <div
            onClick={() => {
              setLoading(true);
              clearResumeWatching();
              setResumeMe(null);
            }}
            className={styles.clearAll}
          >
            Clear All
          </div>
        ) : null}
      </div>
    )}
  </>
);

const CustomRightArrow = ({ onClick, align }) => (
  <RightArrow
    fontSize="large"
    onClick={onClick}
    aria-label="Go to next slide"
    className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right custom_arrow custom-next"
    // className="right-arrow"
    // style={{ marginTop: align && '5px' }}
  />
);

const CustomLeftArrow = ({ onClick }) => (
  <LeftArrow
    onClick={onClick}
    aria-label="Go to next slide"
    className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left custom_arrow custom-prev"
    // className="left-arrow"
    // style={{ zIndex: '1000', cursor: 'pointer', height: '40px', marginLeft: '-100%', background: 'none' }}
  />
);
const ViewMyProjector = ({
  pagination,
  albumPagination,
  offset,
  setVideoOffset,
  fetchData,
  imageData,
  isphoto,
  resumeMe,
  setResumeMe,
  responseData,
  profileDetails,
  title,
  isGrid,
  type,
  catG,
  resumeWatching,
  setLoading,
  clearResumeWatching,
  isPreview,
  handleCarousel,
}) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 2, // optional, default to 1.
    },
  };
  const responsiveImage = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1.5,
      slidesToSlide: 2, // optional, default to 1.
    },
  };
  const navigate = useNavigate();
  const { getToken } = useContext(AuthContext);
  const { loader, setLoader, setcategoryLoader } = useContext(AppContext);
  const carouselRefs = useRef({});
  const [currentSlides, setCurrentSlides] = useState({});
  const [isMoving, setMoving] = useState(false);
  const [showArrow, setArrows] = useState(false);
  const [showAutoPlayDiv, setAutoPlayDiv] = useState(undefined);
  const filteredPhotos = imageData?.data?.filter(
    (element) => element?.photos && element?.photos?.length > 0
  );
  let myTimeout;
  const [dimensions, setDimensions] = useState({
    // top: '0px',
    // left: '0px',
  });
  const [videoDetails, setVideoDetails] = useState({
    videoURL: '',
    thumbNail: '',
    title: '',
    subCategory: '',
  });
  const mouseOverHandler = (
    event,
    id,
    video_file,
    thumbnails,
    title,
    subCategory,
    video_raw_file
  ) => {
    const rect = event.target.getBoundingClientRect();
    setDimensions({});
    setAutoPlayDiv(id);
    setVideoDetails({
      videoURL: video_file || video_raw_file,
      thumbNail: thumbnails,
      title,
      subCategory,
    });
  };

  const mouseLeaveHandler = () => {
    clearInterval(myTimeout);
    setAutoPlayDiv(undefined);
    setVideoDetails({
      videoURL: '',
      thumbNail: '',
      title: '',
      subCategory: '',
    });
  };

  useEffect(() => {
    const autoPlayElement = document?.getElementById('autoplay-div');
    const thumbnailLinkElement = document?.getElementById('thumbnail-link');
    autoPlayElement?.addEventListener('mouseleave', mouseLeaveHandler);
    return () => autoPlayElement?.removeEventListener('mouseleave', mouseLeaveHandler);
  });
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLoader(false);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, []);
  const [swiperStates, setSwiperStates] = useState({}); // e.g., { [categoryId]: { atEnd: false, atBeginning: true } }

  function beforeChange(index, type, obj) {
    if (index >= 3 && obj?.videoPagination?.hasNextPage === true) {
      setVideoOffset((prevOffsets) => {
        const newOffset = (prevOffsets[obj?.category_id ?? obj?.playlist_id] ?? 0) + 10; // Ensure correct starting offset
        fetchData(offset, obj?.category_id ?? obj?.playlist_id, newOffset); // ✅ Pass pageOffset & categoryVideoOffset separately
        return {
          ...prevOffsets,
          [obj?.category_id ?? obj?.playlist_id]: newOffset,
        }; // Update state properly
      });
    }
  }
  const currentOffset = useRef(10); // start at 10 since 0 is already loaded

  function albumUpdater(index, type, obj) {
    if (index >= 3 && albumPagination?.hasNextPage === true) {
      fetchData(currentOffset.current);
      currentOffset.current += 10; // increment after fetching
    }
  }
  useEffect(() => {
    responseData.forEach((obj) => {
      const categoryId = obj?.category_id;
      const lastSlide = currentSlides[categoryId] || 0;

      if (carouselRefs.current[categoryId]) {
        setTimeout(() => {
          carouselRefs.current[categoryId].goToSlide(lastSlide);
          console.log(`Restored carousel ${categoryId} to slide ${lastSlide}`);
        }, 200);
      }
    });
  }, [responseData]); // Run when responseData updates
  const [loadedImages, setLoadedImages] = useState({});

  return (
    <div>
      {loader === true ? (
        <ProgressBar fullProgress="yes" />
      ) : (
        <div
          className={cn({
            [styles.paddingTop0]: true,
            [styles.imageGroup]: true,
            [styles.paddingTopForImage]: catG,
          })}
        >
          <div
            style={{ alignItems: 'baseline' }}
            className={styles.headingWrapper}
          >
            {responseData?.content_type === 'Resume Watching'
              && responseData?.content?.length > 0 && (
                <ImageGroupTitle
                  title="Resume watching"
                  marginTitle={catG}
                  resumeWatching={resumeWatching}
                  setLoading={setLoading}
                  clearResumeWatching={clearResumeWatching}
                />
              )}
            {responseData?.content_type === 'Resume Watching'
            && responseData?.content?.length > 0 ? (
              <div
                onClick={() => {
                  setcategoryLoader(true);
                  setLoading(true);
                  clearResumeWatching();
                  setResumeMe(null);
                }}
                className={styles.clearAll}
              >
                Clear All
              </div>
            ) : null}
          </div>
          {/* {searchTerm && <ImageGroupTitle title={`Search results for "${searchTerm}"`} />} */}
          <div>
            <div
              className={cn({
                [styles.imageGroupImagesContainer]: true,
                [styles.isGrid]: isGrid,
              })}
            >
              {/* resume watching */}
              {responseData?.content_type === 'Resume Watching'
                && responseData?.content?.length > 0 && (
                  <ImageGroupTitle
                    setResumeMe={setResumeMe}
                    resumeMe={resumeMe}
                    title={resumeMe?.content_type}
                    marginTitle={catG}
                    resumeWatching={resumeWatching}
                    setLoading={setLoading}
                    clearResumeWatching={clearResumeWatching}
                  />
                )}
              <div
                onMouseEnter={() => setArrows(true)}
                onMouseLeave={() => setArrows(false)}
              >
                <Carousel
                  // swipeable={isTrueValue}
                  // draggable={isTrueValue}
                  // showDots={searchTerm ? false : isTrueValue}
                  arrows
                  slidesToSlide={3}
                  responsive={responsive}
                  ssr={isTrueValue} // means to render carousel on server-side.
                  autoPlaySpeed={1000}
                  keyBoardControl={isTrueValue}
                  // customTransition="all 20"
                  // transitionDuration={10000}
                  // arrows={showArrow}
                  containerClass="carousel-container"
                  dotListClass="custom-dot-list-style"
                  itemClass={`image-item spclMargin ${
                    isGrid && styles['image-item-isGrid']
                  }`}
                  customRightArrow={<CustomRightArrow />}
                  customLeftArrow={<CustomLeftArrow />}
                  beforeChange={(p) => beforeChange(p, type)}
                  afterChange={() => setMoving(false)}
                  centerMode={isTrueValue}
                  className={styles.carousel}
                >
                  {responseData?.content_type === 'Resume Watching'
                    && responseData?.content?.length > 0
                    && responseData?.content?.map((obj, idx) => (
                      <div className={styles.imageGroupImagesWrapper}>
                        <Box className={styles.hoverZoom} key={idx}>
                          <Link
                            onMouseEnter={(event) => mouseOverHandler(
                                event,
                                idx,
                                obj?.video_file,
                                obj?.thumbnails,
                                obj?.videoTitle,
                                obj?.SubCategory,
                                obj?.video_raw_file
                              )}
                            onMouseLeave={mouseLeaveHandler}
                            className={styles.imageGroupImageLink}
                            key={idx} // Add a unique key prop for each item in the map function
                            to={
                              isPreview
                                ? `${Pathname.getPlayerPath(obj?.id, 'play')}`
                                : Pathname.getVideoPath(obj?.id)
                            }
                            id="thumbnail-link"
                          >
                            <VideoAutoPlayer
                              dimensions={dimensions}
                              videoDetails={resumeMe?.content[idx]}
                              thumbNail={
                                obj?.imagekit_icon
                                || obj?.thumbnails
                                || AlterImage
                              }
                              videoID={showAutoPlayDiv}
                              // autoPlay={showAutoPlayDiv === idx}
                            />
                            <TitleLabel
                              title={obj?.title}
                              category={obj?.SubCategory}
                            />
                          </Link>
                        </Box>
                      </div>
                    ))}
                  {/* A blank div added to compromise the carousel bug TODO find bug */}
                  <div />
                </Carousel>
              </div>
              {type === 'photo_album'
                && Array.isArray(responseData)
                && responseData.length > 0 && (
                  <ImageGroupTitle title={`${profileDetails} Photo Album`} />
                )}
              {type === 'photo_album'
                && Array.isArray(responseData)
                && responseData.length > 0 && (
                  <div style={{ width: '100%' }}>
                    <Swiper
                      style={{ paddingLeft: '10px', paddingRight: '10px' }}
                      onSwiper={(swiper) => {
                        setTimeout(() => {
                          swiper.update(); // force recalc after DOM is painted
                        }, 100);
                      }}
                      slidesPerView={6}
                      spaceBetween={5}
                      navigation
                      // loop
                      slidesPerGroup={3}
                      pagination={false}
                      modules={[Navigation]}
                      onSlideChange={(swiper) => {
                        albumUpdater(swiper.activeIndex);
                      }}
                    >
                      {responseData?.map((obj, index) => (
                        <SwiperSlide key={index}>
                          <div className={styles.imageGroupImagesWrapper}>
                            <Box className={styles.hoverZoom}>
                              <Link
                                className={cn({
                                  [styles.imageGroupImageLink]: true,
                                  [styles.albumTransition]: true,
                                })}
                                key={index}
                                to={Pathname.getAlbumPath(obj?.id)}
                              >
                                <div className={styles.imagePlaceholder}>
                                  {!loadedImages[obj.id] && (
                                    <div className={styles.ShimmerLoaderImage} />
                                  )}
                                  <Image
                                    src={obj?.icon}
                                    className={`${styles.imageGroupImage}`}
                                    onLoad={() => setLoadedImages((prev) => ({
                                        ...prev,
                                        [obj.id]: true,
                                      }))}
                                    onError={(e) => {
                                      e.target.src = AlterImage;
                                      setLoadedImages((prev) => ({
                                        ...prev,
                                        [obj.id]: true,
                                      }));
                                    }}
                                  />
                                </div>
                                <TitleLabel title={obj?.title} />
                              </Link>
                            </Box>
                          </div>
                        </SwiperSlide>
                      ))}
                      <div />
                    </Swiper>
                  </div>
                )}
              {/* playlist section */}
              {/* {type === 'playlists' && Array.isArray(responseData) && responseData.length > 0 && (
  <ImageGroupTitle title="Playlists" />
)} */}
              <div>
                {type === 'playlists'
                  && responseData?.map((obj, i) => (
                    <div key={i}>
                      {obj?.videos?.length > 0 && (
                        <ImageGroupTitle
                          title={obj?.playlist_title}
                          marginTitle={catG}
                          resumeWatching={resumeWatching}
                          setLoading={setLoading}
                          clearResumeWatching={clearResumeWatching}
                        />
                      )}

                      {obj?.videos?.length > 0 && (
                        <div
                          onMouseEnter={() => setArrows(true)}
                          onMouseLeave={() => setArrows(false)}
                        >
                          <Swiper
                            style={{
                              paddingLeft: '10px',
                              paddingRight: '10px',
                            }}
                            onSwiper={(swiper) => {
                              setSwiperStates((prev) => ({
                                ...prev,
                                [obj.category_id]: {
                                  atBeginning: swiper.isBeginning,
                                  atEnd: swiper.isEnd,
                                },
                              }));
                            }}
                            slidesPerView={4}
                            spaceBetween={20}
                            navigation
                            // loop
                            slidesPerGroup={2}
                            pagination={false}
                            modules={[Navigation]}
                            onSlideChange={(swiper) => {
                              beforeChange(swiper.activeIndex, type, obj); // ✅ existing logic

                              setSwiperStates((prev) => ({
                                ...prev,
                                [obj.category_id]: {
                                  atBeginning: swiper.isBeginning,
                                  atEnd: swiper.isEnd,
                                },
                              }));
                            }}
                          >
                            {obj?.videos?.map(
                              (
                                {
                                  id,
                                  thumbnails,
                                  imagekit_icon,
                                  draft_thumbnails,
                                  title: videoTitle,
                                  SubCategory,
                                  video_file,
                                  video_raw_file,
                                },
                                idx
                              ) => (
                                <SwiperSlide key={idx}>
                                  <div
                                    className={styles.imageGroupImagesWrapper}
                                  >
                                    <Box className={styles.hoverZoom}>
                                      <Link
                                        onMouseEnter={(event) => mouseOverHandler(
                                            event,
                                            id,
                                            video_file,
                                            thumbnails,
                                            videoTitle,
                                            SubCategory,
                                            video_raw_file
                                          )}
                                        onMouseLeave={mouseLeaveHandler}
                                        className={styles.imageGroupImageLink}
                                        to={
                                          isPreview
                                            ? `${Pathname.getPlayerPath(
                                                id,
                                                'play'
                                              )}`
                                            : Pathname.getVideoPath(id)
                                        }
                                        id="thumbnail-link"
                                      >
                                        <VideoAutoPlayer
                                          dimensions={dimensions}
                                          videoDetails={obj?.videos[idx]}
                                          thumbNail={(() => {
                                            try {
                                              return Array.isArray(thumbnails)
                                                ? thumbnails[0]
                                                : JSON.parse(thumbnails)?.[0]
                                                    || AlterImage;
                                            } catch (error) {
                                              console.error(
                                                'Error parsing thumbnails:',
                                                error
                                              );
                                              return AlterImage;
                                            }
                                          })()}
                                          videoID={showAutoPlayDiv}
                                          // autoPlay={showAutoPlayDiv === id}
                                        />
                                        <TitleLabel
                                          title={videoTitle}
                                          category={SubCategory}
                                        />
                                      </Link>
                                    </Box>
                                  </div>
                                </SwiperSlide>
                              )
                            )}
                            <div />
{' '}
{/* Carousel bug workaround */}
                          </Swiper>
                        </div>
                      )}
                    </div>
                  ))}
                {type === 'playlists' && pagination?.hasNextPage && (
                  <div className={styles.shimmerWrapper}>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <div key={index} className={styles.ShimmerLoader} />
                    ))}
                  </div>
                )}
              </div>
              {/* {type === 'categories' && Array.isArray(responseData) && responseData.length > 0 && (
  <ImageGroupTitle title="Categories" />
)} */}
              <div>
                {type === 'categories'
                  && responseData?.map((obj, i) => (
                    <div key={i}>
                      {obj?.videos?.length > 0 && (
                        <ImageGroupTitle
                          title={obj?.category_name}
                          marginTitle={catG}
                          resumeWatching={resumeWatching}
                          setLoading={setLoading}
                          clearResumeWatching={clearResumeWatching}
                        />
                      )}

                      {obj?.videos?.length > 0 && (
                        <div
                          onMouseEnter={() => setArrows(true)}
                          onMouseLeave={() => setArrows(false)}
                        >
                          <Swiper
                            style={{
                              paddingLeft: '10px',
                              paddingRight: '10px',
                            }}
                            onSwiper={(swiper) => {
                              setSwiperStates((prev) => ({
                                ...prev,
                                [obj.category_id]: {
                                  atBeginning: swiper.isBeginning,
                                  atEnd: swiper.isEnd,
                                },
                              }));
                            }}
                            slidesPerView={4}
                            spaceBetween={5}
                            navigation
                            // loop
                            slidesPerGroup={2}
                            pagination={false}
                            modules={[Navigation]}
                            onSlideChange={(swiper) => {
                              beforeChange(swiper.activeIndex, type, obj); // ✅ existing logic
                              setSwiperStates((prev) => ({
                                ...prev,
                                [obj.category_id]: {
                                  atBeginning: swiper.isBeginning,
                                  atEnd: swiper.isEnd,
                                },
                              }));
                            }}
                          >
{obj?.videos
  ?.filter((video) => video && video.id)
  ?.map((video, idx) => (
    <SwiperSlide key={idx}>
      <div className={styles.imageGroupImagesWrapper}>
        <Box className={styles.hoverZoom}>
          <Link
            onMouseEnter={(event) => mouseOverHandler(
                event,
                video?.id,
                video?.video_file,
                video?.thumbnails,
                video?.title,
                video?.SubCategory,
                video?.video_raw_file
              )}
            onMouseLeave={mouseLeaveHandler}
            className={styles.imageGroupImageLink}
            to={
              isPreview
                ? `${Pathname.getPlayerPath(video?.id, 'play')}`
                : Pathname.getVideoPath(video?.id)
            }
            id="thumbnail-link"
          >
            <VideoAutoPlayer
              dimensions={dimensions}
              videoDetails={video}
              thumbNail={(() => {
                try {
                  if (Array.isArray(video?.thumbnails)) {
                    return video?.thumbnails[0] || AlterImage;
                  }
                  const parsed = JSON.parse(video?.thumbnails);
                  return parsed?.[0] ?? AlterImage;
                } catch (error) {
                  console.error('Error parsing thumbnails:', error);
                  return AlterImage;
                }
              })()}
              videoID={showAutoPlayDiv}
            />
            <TitleLabel
              title={video?.title}
              category={video?.SubCategory}
            />
          </Link>
        </Box>
      </div>
    </SwiperSlide>
  ))}

                            <div />
{' '}
{/* Carousel bug workaround */}
                          </Swiper>
                        </div>
                      )}
                    </div>
                  ))}
                {type === 'categories' && pagination?.hasNextPage && (
                  <div className={styles.shimmerWrapper}>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <div key={index} className={styles.ShimmerLoader} />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ViewMyProjector;
